<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Audio Tracks</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Order Audio Tracks</strong>
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="{ name: 'AlbumManageTracks', params: { id: $route.params.id }}"
          >
            Manage Audio Tracks
          </router-link>
        </div>

        <div class="card-block spinner-parent">
          <spinner ref="spinner" size="md" text="Loading ..." />

          <SlickList v-model="tracks" class="slicksort-wrap " lock-axis="y">
            <SlickItem v-for="(track, index) in tracks" :key="index" :index="index" class="slicksort-item">
              {{ track.title }}
            </SlickItem>
          </SlickList>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span ref="saveBtnLoader" class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Order has changed successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash';
import { SlickList, SlickItem } from 'vue-slicksort';

export default {
  name: 'AlbumOrderTracks',

  components: {
    SlickItem,
    SlickList,
  },

  data() {
    return {
      tracks: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  mounted() {
    this.getTracks();
  },

  methods: {
    getTracks() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/audio-albums/${this.$route.params.id}/tracks`, {
        params: {
          nonpaginated: true,
        },
      })
        .then((response) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.tracks = this.orderByWeight(response.data);
        }).catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          console.error(error);
        });
    },
    orderByWeight(arr) {
      return arr.sort((a, b) => {
        const weightA = a.weight ? +a.weight : 0;
        const weightB = b.weight ? +b.weight : 0;
        if (weightA > weightB) {
          return 1;
        }
        return -1;
      });
    },
    save() {
      $(this.$refs.saveBtnLoader).show();
      for (let i = 0; i < this.tracks.length; i += 1) {
        this.tracks[i].weight = i;
      }
      this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/audio/${this.$route.params.id}/tracks/bulk-update`,
        {
          items: this.tracks,
        },
      ).then(() => {
        $(this.$refs.saveBtnLoader).hide();
        $('.saving-alerts .alert-success').show();
      }).catch((error) => {
        $(this.$refs.saveBtnLoader).hide();
        $('.saving-alerts .alert-danger').show();
        console.error(error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// OrderTracks.vue?1761faee